// extracted by mini-css-extract-plugin
export default {"wrapper":"AdditionalInformation_wrapper__tEaHd","label":"AdditionalInformation_label__XB5L5","saveSettingsTemplate":"AdditionalInformation_saveSettingsTemplate__J2ICX"};